var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCultivatedFungiBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.036,
    height: 17.077,
    viewBox: "0 0 15.036 17.077",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3373",
    "data-name": "Group 3373",
    transform: "translate(0.351 0.35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3507",
    "data-name": "Path 3507",
    d: "M2808,236.919c-.117,0-.2,0-.234,0a7.724,7.724,0,0,1-2.3-.27,2.118,2.118,0,0,1-1.126-.821,4.253,4.253,0,0,1-.272-3.425l.423-1.76a.35.35,0,0,1,.681.163l-.423,1.76a3.624,3.624,0,0,0,.17,2.867,1.416,1.416,0,0,0,.754.547,7.116,7.116,0,0,0,2.076.238h.033a7.15,7.15,0,0,0,2.076-.238,1.415,1.415,0,0,0,.754-.547,3.625,3.625,0,0,0,.171-2.866l-.424-1.762a.35.35,0,0,1,.681-.164l.424,1.762a4.253,4.253,0,0,1-.273,3.424,2.116,2.116,0,0,1-1.126.821A7.458,7.458,0,0,1,2808,236.919Z",
    transform: "translate(-2800.605 -220.193)",
    fill: "#22294D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3508",
    "data-name": "Path 3508",
    d: "M2795.363,183.522h0a7.7,7.7,0,0,1,5.607,2.384,6.139,6.139,0,0,1,1.92,3.7.335.335,0,0,1-.006.059c-.074.486-.671,2.01-5.2,2.01h-4.634c-1.44,0-4-.184-4.969-1.415-.359-.456-.279-1.305.219-2.33a8.174,8.174,0,0,1,2.511-2.93A7.737,7.737,0,0,1,2795.363,183.522Zm6.828,6.048a5.582,5.582,0,0,0-1.721-3.175,7.018,7.018,0,0,0-5.107-2.173h0a7.04,7.04,0,0,0-4.146,1.349,7.45,7.45,0,0,0-2.291,2.669c-.431.887-.412,1.447-.3,1.591.271.345,1.245,1.147,4.419,1.147h4.634C2801.065,190.978,2802.107,190.1,2802.191,189.57Z",
    transform: "translate(-2788.207 -183.872)",
    fill: "#22294D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3509",
    "data-name": "Path 3509",
    d: "M2808.409,221.14h0a1.856,1.856,0,0,1-1.23-.463,1.451,1.451,0,0,1-1.72-.093,2.073,2.073,0,0,1-.536-2.577l.581-1.117a.35.35,0,0,1,.621.323l-.581,1.117a1.364,1.364,0,0,0,.341,1.7.787.787,0,0,0,1.095-.078.35.35,0,0,1,.511.042,1.164,1.164,0,0,0,.918.447h0a1.165,1.165,0,0,0,.919-.447.35.35,0,0,1,.511-.042.789.789,0,0,0,1.1.074,1.361,1.361,0,0,0,.339-1.7l-.581-1.117a.35.35,0,0,1,.621-.323l.581,1.117a2.069,2.069,0,0,1-.533,2.573,1.454,1.454,0,0,1-1.722.1A1.857,1.857,0,0,1,2808.409,221.14Z",
    transform: "translate(-2801.253 -209.596)",
    fill: "#22294D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCultivatedFungiBlue);
export default __webpack_public_path__ + "static/media/cultivated_fungi_blue.913ac1fbb4bc8c1b821c1bfed78b2802.svg";
export { ForwardRef as ReactComponent };